import HomeNew from "../HomeNew/HomeNew";
import HomeVersion2 from "../HomeNew/HomeVersion2";

const Home = () => {

  return (
    // <HomeNew />
    <HomeVersion2 />
  );
};

export default Home;
